import CommercialHero from './components/CommercialHero';
import CommercialServices from './components/CommercialServices';
import CommercialShowcase from './components/CommercialShowcase';
import CommercialFAQ from './components/CommercialFAQ';
import CommercialCTA from './components/CommercialCTA';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://tadashiconsulting.co.za';

const commercialJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Premium Commercial Construction & Fit-Outs Johannesburg',
    description:
      'High-end commercial renovations for offices, retail spaces, restaurants and hospitality venues across Johannesburg. Expert construction with minimal business disruption by licensed contractors.',
    provider: {
      '@type': 'HomeAndConstructionBusiness',
      name: 'Tadashi Consulting',
      url: siteUrl,
      telephone: '+27118752075',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Randburg',
        addressRegion: 'Gauteng',
        addressCountry: 'ZA',
      },
    },
    areaServed: { '@type': 'City', name: 'Johannesburg' },
    serviceType: 'Commercial Construction',
    url: `${siteUrl}/commercial-construction`,
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Commercial Construction Services',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Office Fit-Outs' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Retail Space Renovations' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Restaurant & Hospitality Fit-Outs' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Commercial Structural Upgrades' } },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Premium Commercial Construction & Fit-Outs Johannesburg | Tadashi Consulting',
    url: `${siteUrl}/commercial-construction`,
    description:
      'High-end commercial renovations for offices, retail and hospitality venues in Johannesburg. Expert construction with minimal business disruption.',
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: 'Commercial Construction', item: `${siteUrl}/commercial-construction` },
      ],
    },
  },
];

export default function CommercialPage() {
  return (
    <main className="min-h-screen bg-white">
      <SeoHead
        title="Commercial Construction & Fit-Outs Johannesburg | Tadashi Consulting"
        description="Premium commercial construction and fit-outs for offices, retail spaces, restaurants and hospitality venues in Johannesburg. Tadashi Consulting delivers high-end commercial renovations with minimal business disruption. Licensed contractors, expert craftsmanship."
        keywords="commercial construction Johannesburg, office fit-outs Gauteng, retail renovation South Africa, hospitality fit-outs Randburg, commercial contractors Johannesburg"
        canonical={`${siteUrl}/commercial-construction`}
        ogTitle="Premium Commercial Construction & Fit-Outs Johannesburg | Tadashi Consulting"
        ogDescription="High-end commercial renovations for offices, retail and hospitality venues across Johannesburg. Expert construction with minimal business disruption."
        jsonLd={commercialJsonLd}
      />
      <CommercialHero />
      <CommercialServices />
      <CommercialShowcase />
      <CommercialFAQ />
      <CommercialCTA />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
